import { styled } from '@mui/material/styles'

export const FormWrapper = styled('div')`
  height: 100%;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const PageWrapper = styled('div')`
  height: 100%;
  width: 100%;
  background: #e8e8e8;
  color: #2B2B2B
`

export const StyledForm = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ButtonsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const LinkText = styled('button')`
  all: unset;
  cursor: pointer;
  color: #2b2b2b;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  text-align: center;
  margin: 8px 0 16px 0;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`

export const ErrorMessage = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 30%;
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 16px;
`
